import { Signaling } from "./signaling";

export class MasterSignaling implements Signaling {
	constructor(
		private user, // This is the catlabremote.Webremote object
		private listener
	) {
		
		user.events.on('webrtc', (msg) => {
			this.listener(msg);
		});

	}

    send(message) {
        this.user.events.trigger('webrtc', message);
    }
}